import { render, staticRenderFns } from "./BlockAudienceModal.vue?vue&type=template&id=17743880&scoped=true&"
import script from "./BlockAudienceModal.vue?vue&type=script&lang=js&"
export * from "./BlockAudienceModal.vue?vue&type=script&lang=js&"
import style0 from "./BlockAudienceModal.vue?vue&type=style&index=0&id=17743880&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17743880",
  null
  
)

export default component.exports